<template>
    <el-tabs type="border-card" v-model="currentTab">
        <el-tab-pane label="分享者管理" name="second">
            <rebate_agent v-if="currentTab == 'second'"></rebate_agent>
        </el-tab-pane>
    </el-tabs>

</template>
<script>
    import {rebateLevelApi} from "../../common/rebateLevel";

    export default {
        name: "index",
        components: {
            rebate_agent: require('./rebate_agent').default,
        },
        watch: {},
        created() {

        },
        mounted() {


        },
        data() {
            return {
                labelPosition: 'left',
                activeNames: [],
                maxRules: 5,
                maxLevels: 5,
                items: [],
                open: false,
                currentTab: 'second',
            }
        },
        created() {
            var that = this;

        },
        methods: {
            initRule(rebateRules) {
                if (!rebateRules.rebateRules) {
                    rebateRules.rebateRules = []
                }
                rebateRules.rebateRules.splice(0, 0, {
                    from: 0,
                    to: 10,
                    rate: "30%",
                    parentOneRate: "10%",
                    parentTwoRate: "5%"
                })

            },
            addRule(rebateRules, index) {
                if (!rebateRules.rebateRules) {
                    rebateRules.rebateRules = []
                }
                if (rebateRules.rebateRules.length >= this.maxRules) {
                    this.failMsg("最大支持" + this.maxRules + "个规则");
                    return;
                }
                rebateRules.rebateRules.splice(index + 1, 0, {
                    from: 0,
                    to: 10,
                    rate: "30%",
                    parentOneRate: "10%",
                    parentTwoRate: "5%"
                });
            },
            deleteRule(rules, index) {
                rules.splice(index, 1)
            },
            addLevel() {
                if (this.items.length >= this.maxLevels) {
                    this.failMsg("最大支持" + this.maxLevels + "个级别")
                    return;
                }
                this.items.push(
                    {
                        levelName: '级别名称，如普通合伙人',
                        fromParentCount: 0,
                        toParentCount: 0,
                        rebateRules: {
                            rebateRules: []
                        }
                    },
                );
                this.activeNames = [this.items.length - 1]
            },
            deleteLevel(item, index) {
                var that = this
                item.visible = false
                that.items.splice(index, 1)
                rebateLevelApi.updateRebateLevels.call(that, {userLevelRules: that.items})
            },
            onSubmit() {
                var that = this;
                rebateLevelApi.updateRebateLevels.call(that, {userLevelRules: that.items, open: that.open})
            }
        }
    }

</script>
<style lang="scss">

    .user-rebate-level {
        text-align: left;

        .rules {
            margin-bottom: 10px;
        }

        .line {
            text-align: center;
        }


        .opt {
            margin-left: 10px;
        }

        .head-tip {
            margin-left: 10px;
            color: #ff0036;
        }

        .tip {
            color: #409EFF;
            font-weight: 500;
        }


        .title {
            margin-left: 10px;
            display: flex;
            align-items: center;

            .trigger {
                margin-left: 20px;
            }

            strong {
                color: $hover-color;
            }

        }

        .el-collapse {
            border: none;
        }

        .el-collapse-item__wrap {
            border: none;
        }


        .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

</style>